(() => {
  const desktopHover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  const syncExpandedState = (details) => {
    const summary = details.querySelector(':scope > summary');
    if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
  };

  const closeMenu = (details, returnFocus = false) => {
    details.open = false;
    syncExpandedState(details);
    if (returnFocus) details.querySelector(':scope > summary')?.focus();
  };

  const openMenu = (details) => {
    document.querySelectorAll('[data-neat-hover-menu][open]').forEach((openDetails) => {
      if (openDetails !== details) closeMenu(openDetails);
    });
    details.open = true;
    syncExpandedState(details);
  };

  const bindHoverMenu = (details) => {
    if (details.dataset.neatHoverBound === 'true') return;
    details.dataset.neatHoverBound = 'true';
    let closeTimer;

    const cancelClose = () => window.clearTimeout(closeTimer);
    const scheduleClose = () => {
      cancelClose();
      closeTimer = window.setTimeout(() => closeMenu(details), 140);
    };

    details.addEventListener('pointerenter', () => {
      if (!desktopHover.matches) return;
      cancelClose();
      openMenu(details);
    });

    details.addEventListener('pointerleave', () => {
      if (desktopHover.matches) scheduleClose();
    });

    details.addEventListener('focusout', (event) => {
      if (!details.contains(event.relatedTarget)) scheduleClose();
    });

    details.addEventListener('toggle', () => syncExpandedState(details));
    details.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !details.open) return;
      event.preventDefault();
      closeMenu(details, true);
    });

    syncExpandedState(details);
  };

  const initialize = (root = document) => {
    root.querySelectorAll('[data-neat-hover-menu]').forEach(bindHoverMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
